// extracted by mini-css-extract-plugin
export default {"container":"TournamentsList_container__fg6aI","titleRow":"TournamentsList_titleRow__oQcWY","title":"TournamentsList_title__hh7bv","row":"TournamentsList_row__RjVqN"};